import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Cleave from 'cleave.js/dist/cleave-react'
import _ from 'lodash'

const PriceInputContainer = ({
  scheduleFactor,
  ratedPremium,
  onBlurTextboxHandler,
  options,
  disable,
}) => {
  const [value, setValue] = useState('')
  const [modifiedCreditDebit, setModifiedCreditDebit] = useState([])

  useEffect(() => {
    if (scheduleFactor !== 0 && scheduleFactor !== value) {
      setModifiedCreditDebit([scheduleFactor])
    }
  }, [scheduleFactor])

  const handleKeyDown = () => {
    if (value === 0) {
      setValue('')
    }
  }

  const onBlur = (event) => {
    let val = Number(event.target.value)
    val = _.isNaN(val) ? 0 : val
    let prem = ratedPremium * val
    prem = prem.toString().indexOf('.') !== -1 ? Number(prem.toFixed(2)) : prem
    onBlurTextboxHandler(
      { [event.target.id]: prem },
      modifiedCreditDebit,
      event.target.value,
    )
    setValue(event.target.value)
  }

  const _value = scheduleFactor && scheduleFactor !== value ? scheduleFactor : value
  const getValue = () => {
    if (_value && (String(_value).endsWith('.') || _value % 1 !== 0)) {
      return _value
    }

    if (_value && typeof _value === 'number') {
      return _value.toFixed(1)
    }

    return _value
  }

  return (
    <div style={{ height: '34px' }}>
      <div className="row" style={{ height: '34px' }}>
        <Cleave
          id={options.value}
          className={classNames(
            'form-control',
            'number-control',
            'input-numeral',
            'credit-debit',
            'price-input-container',
            'col-xs-10',
          )}
          disabled={disable}
          autoComplete={false}
          value={getValue()}
          options={{
            numeral: true,
            numeralPositveOnly: true,
            numeralThousandsGroupStyle: 'none',
            numeralDecimalScale: 4,
            numeralDecimalMark: '.',
          }}
          onBlur={onBlur}
          onKeyDown={handleKeyDown}
        />
      </div>
      {!Number.isNaN(Number.parseFloat(_value)) && Number.parseFloat(_value) < 0 && Number.parseFloat(_value) !== 0 && !disable ? (
        <p className="Maxlimit">{`Negative numbers are not allowed`} </p>
      ) : (
        ''
      )}
    </div>
  )
}

export default PriceInputContainer
